import { 
    Button,
    Modal, ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure }
from "@chakra-ui/react";


export function WelcomeModal() {
const { isOpen, onClose } = useDisclosure({ defaultIsOpen : true })


return (
    <div>
    <Modal isOpen={isOpen} onClose={onClose} size={"2xl"} isCentered>
        <ModalOverlay />
        <ModalContent textAlign={"center"}>
        <ModalHeader>Welcome</ModalHeader>
        <ModalBody>
         In the next pages, you'll find some text and ideas for consideration.
        <br/>  
        You're welcome to browse and use them as you choose. 
        </ModalBody>

        <ModalFooter justifyContent={"center"}>
            <Button colorScheme="purple" mr={3} onClick={onClose} variant={"solid"}>
            Close & Explore
            </Button>
        </ModalFooter>
        </ModalContent>
    </Modal>
    </div>
)

}